import { mountGame } from '../render/three/game-app.js';
import { makeSpiderSpec } from '../variants/spider/spec.js';
import type { SpiderSuitCount } from '../variants/spider/rules.js';

const params = new URLSearchParams(location.search);
const raw = params.get('suits');
const suits: SpiderSuitCount = raw === '1' ? 1 : raw === '2' ? 2 : 4;

const titleEl = document.querySelector('.hud h1');
if (titleEl && suits !== 4) {
  titleEl.textContent = `Spider · ${suits} suit${suits === 1 ? '' : 's'}`;
}

await mountGame(makeSpiderSpec({ suits }));
